
                    module.exports = {"name":"small-plus","data":{"width":"17","height":"13","viewBox":"0 0 17 13","data":"<path pid=\"0\" d=\"M5 3v7M1.5 6.5h7\" _stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"}}
            